import { useTranslation } from 'i18next-vue';

import { ContactMethod } from './types';

export const getVerboseContactMethod = (type: ContactMethod) => {
  const { t } = useTranslation();

  switch (type) {
    case ContactMethod.Call:
      return t('request-form.contact-method.types.call');
    case ContactMethod.WriteWhatsApp:
      return t('request-form.contact-method.types.write-whatsapp');
    case ContactMethod.WriteTelegram:
      return t('request-form.contact-method.types.write-telegram');
  }
};
